module.exports = __webpack_public_path__ + "static/media/small2.a54df951.png";